import { FileQuestionMark } from 'lucide-react';
import React from 'react';
import { MarkdownRenderer } from '~/components/MarkdownRenderer';
import { Button } from '~/components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '~/components/ui/dialog';
import { Separator } from '~/components/ui/separator';
import { cn } from '~/lib/utils';

const docFiles = [
  { name: 'Core concept', path: '/INTRO.md' },
  { name: 'Template', path: '/TEMPLATE.md' },
  { name: 'Data', path: '/DATA.MD' },
  { name: 'Static Assets', path: '/ASSETS.MD' },
];

export const Documentation: React.FC = () => {
  const [selectedFile, setSelectedFile] = React.useState(docFiles[0].path);

  const handleFileChange = (filePath: string) => {
    setSelectedFile(filePath);
  };

  return (
    <div className='w-full flex'>
      <Dialog>
        <DialogTrigger asChild>
          <Button variant='outline' className='ms-auto'>
            <FileQuestionMark /> Help / Docs
          </Button>
        </DialogTrigger>
        <DialogContent className='flex gap-1 sm:w-full sm:max-w-11/12 h-11/12'>
          <div className='flex flex-col gap-2 p-4 ps-0'>
            {docFiles.map((file) => (
              <Button
                key={file.path}
                onClick={() => handleFileChange(file.path)}
                variant='ghost'
                className={cn('w-fit', {
                  'bg-accent': selectedFile === file.path,
                })}
              >
                {file.name}
              </Button>
            ))}
          </div>
          <Separator orientation='vertical' />
          <div className='flex flex-1 h-full p-4'>
            <MarkdownRenderer filePath={selectedFile} />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
